import axios from "axios"
import Gruppo from "../../interfaces/gruppo"

export const createGruppi = (formValues: Gruppo) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/Gruppo`, formValues)
      .then(() => {
        resolve(true)
      })
      .catch((error) => {
        reject(error.response.data.response)
      })
  })
}
export default createGruppi
